import { BRAND_MEDIA } from '../constants/UriConstants';
import { BrandMediaInterface, BrandMediaSaveRequest, BrandMediaTag } from '../types/BrandMediaInterface';
import apiClient from './apiClient';

export const getBrandMedia = (brandID: string): Promise<BrandMediaInterface> =>
  apiClient.get(BRAND_MEDIA(brandID)).then((response) => response.data);

export const saveBrandMedia = (brandID: string, request: BrandMediaSaveRequest): Promise<BrandMediaInterface> => {
  const formData = new FormData();

  if (request.aboutCover) formData.append('aboutCover', request.aboutCover);
  (['profile', 'gallery'] as const).forEach((field) => request[field]?.forEach((blob) => formData.append(field, blob)));
  (['mediaToDelete', 'profileOrder', 'galleryOrder'] as const).forEach((field) =>
    formData.append(field, JSON.stringify(request[field] ?? []))
  );

  return apiClient
    .post(BRAND_MEDIA(brandID), formData, { headers: { 'Content-Type': 'multipart/form-data' } })
    .then((response) => response.data);
};

export const setBrandMediaTag = (brandID: string, mediaID: number, tag: BrandMediaTag | null): Promise<BrandMediaInterface> =>
  apiClient.put(`${BRAND_MEDIA(brandID)}/${mediaID}/tag`, { tag }).then((response) => response.data);
